/**
 * useDate フック
 */

import { useContext } from 'react';
import { DateContextType, DateContext } from '../contexts/DateContext';

export const useDateContext = (): DateContextType => {
  const context = useContext(DateContext);
  if (context === undefined) {
    throw new Error('useDateContextはDateProvider内で使用する必要があります');
  }
  return context;
};
